import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import Registration from './Registration-redux';

export default compose(
    withRouter
)(Registration);
